/**
 * Axios 0.18 возвращает в error.config уже собранный URL, но сохраняет baseURL.
 * Если отправить такой config повторно без нормализации, префикс API добавится
 * ещё раз: /api/admin/api/admin/...
 */
export function prepareRetryConfig (source) {
  const config = Object.assign({}, source)
  const baseURL = config.baseURL
  const url = config.url

  if (!baseURL || !url || baseURL.indexOf('://') !== -1) return config

  const normalizedBaseURL = `/${String(baseURL).replace(/^\/+|\/+$/g, '')}/`
  const normalizedUrl = `/${String(url).replace(/^\/+/, '')}`

  if (normalizedUrl.indexOf(normalizedBaseURL) === 0) {
    config.baseURL = ''
    config.url = normalizedUrl
  }

  return config
}



// WEBPACK FOOTER //
// ./resources/assets/js/api-retry.js